<template>
    <div>
        <!-- ============= 검색 조건============= -->
        <ExtReportSearch v-bind:queryParams="queryParams"
                         v-bind:fullDate="fullDate" />

        <ExtReportList v-bind:queryParams="queryParams"
                       v-bind:fullDate="fullDate" />
    </div>
</template>
<script>
import ExtReportSearch from './component/ExtReportSearch';
import ExtReportList from './component/ExtReportList';
const moment = require("moment");

export default {
    name: "extReportManagementList",
    data() {
        return {
            fullDate: [],
            queryParams: {
                keyword: '',    // 검색 키워드
                status: [],     // 사용유무
                sites: [],      // 사이트
                categorys: [],  // 관심카테고리
                hashtags: [],   // 해시태그 유무
            },
        }
    },
    components: {
        ExtReportSearch,
        ExtReportList,
    },
    methods: {
        getFormatDate(date) {
            if (!date) return;
            return moment(date).format("YYYY-MM-DD");
        },
    },
}
</script>
<style scoped>
  .mx-datepicker{
    width : 100% !important;
  }

  table tr th, td {
    text-align: center;
  }

  .tdClass_tl { text-align: left; }
</style>



// WEBPACK FOOTER //
// src/views/contents/extReport/ExtReportManagementList.vue